import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isActiveUser } from "../../../utils/user/isActiveUser";
import { getUserInfo } from "../../../service/getInfo";
import { getPaymentInfo } from "../services/paymentService";
import useTimeOut from "../../../common/hook/useTimeOut";
import Load from "../../../common/Loader/Load";
import { useUserMora } from "../../../context/userMoraContext";
import UserMora from "../../../common/UserMora";

const DetailsPay = ({ handleChange, form_pay, setform_pay, setGoSteps }) => {
  const [data_pay, setData_pay] = useState(null);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const { isStateMora, setIsStateMora } = useUserMora();

  const formatterPeso = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  });

  const getPay = async () => {
    try {
      const resp = await getPaymentInfo(user.validaciones.codigo);
      setData_pay(resp);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const getInfoUser = async () => {
      try {
        const { data } = await getUserInfo();

        if (data.msg === "Token invalid") {
          localStorage.clear();
          navigate("/");
        } else {
          setUser(data.info);
          setIsStateMora(data.info.validaciones.mora);
          localStorage.setItem("state_mora", data.info.validaciones.mora);

          if (!isActiveUser(data.info)) {
            navigate("/usuario");
          }

          if (data.info.validaciones.chpwd === "1") {
            navigate("/change-password");
            return;
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    getInfoUser();
  }, [navigate, setIsStateMora]);

  useTimeOut(() => getPay(), 1500);

  return (
    <>
      {isStateMora === "1" && (
        <UserMora mmora={user?.validaciones?.mmora} />
      )}

      {data_pay ? (
        <section className="section-payments">
          <h2>Detalles de pago</h2>

          <article className="payment-card">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setGoSteps(1);
              }}
            >
              <div className="payment-info">
                <div className="payment-row">
                  <span className="payment-label">Fecha de pago</span>
                  <strong>{data_pay.fecha_mora || "Estás al día"}</strong>
                </div>

                <div className="payment-row">
                  <span className="payment-label">Cuota sugerida</span>

                  <label htmlFor="cuota_sugerida" className="payment-option">
                    <input
                      type="radio"
                      name="valor"
                      id="cuota_sugerida"
                      onChange={() =>
                        setform_pay({
                          ...form_pay,
                          nombre: user.afiliado1.titular,
                          correo: user.afiliado1.email,
                          contrato: user.contracto.contrato,
                          valor: data_pay.valor_cuota_mes,
                          codigo: user.validaciones.codigo,
                          telefono:
                            user.afiliado1.telefono || user.afiliado2.telefono,
                        })
                      }
                    />

                    <strong>
                      {formatterPeso.format(data_pay.valor_cuota_mes || 0)}
                    </strong>
                  </label>
                </div>

                <div className="payment-row">
                  <span className="payment-label">Pago al día</span>

                  <label htmlFor="pago_al_dia" className="payment-option">
                    <input
                      type="radio"
                      name="valor"
                      id="pago_al_dia"
                      onChange={() =>
                        setform_pay({
                          ...form_pay,
                          nombre: user.afiliado1.titular,
                          correo: user.afiliado1.email,
                          contrato: user.contracto.contrato,
                          valor: data_pay.pago_al_dia,
                          codigo: user.validaciones.codigo,
                          telefono:
                            user.afiliado1.telefono || user.afiliado2.telefono,
                        })
                      }
                    />

                    <strong>
                      {formatterPeso.format(data_pay.pago_al_dia || 0)}
                    </strong>
                  </label>
                </div>

                <div className="payment-row">
                  <span className="payment-label">Pago total</span>

                  <label htmlFor="pago_total" className="payment-option">
                    <input
                      type="radio"
                      name="valor"
                      id="pago_total"
                      onChange={() =>
                        setform_pay({
                          ...form_pay,
                          nombre: user.afiliado1.titular,
                          correo: user.afiliado1.email,
                          contrato: user.contracto.contrato,
                          valor: data_pay.pago_total,
                          codigo: user.validaciones.codigo,
                          telefono:
                            user.afiliado1.telefono || user.afiliado2.telefono,
                        })
                      }
                    />

                    <strong>
                      {formatterPeso.format(data_pay.pago_total || 0)}
                    </strong>
                  </label>
                </div>

                <div className="payment-row">
                  <label htmlFor="otro_valor" className="payment-label">
                    Otro valor
                  </label>

                  <input
                    type="number"
                    id="otro_valor"
                    className="input-pay"
                    placeholder="$0"
                    autoComplete="off"
                    min="1000"
                    required
                    name="valor"
                    value={form_pay.valor}
                    onChange={(e) =>
                      setform_pay({
                        ...form_pay,
                        nombre: user.afiliado1.titular,
                        correo: user.afiliado1.email,
                        contrato: user.contracto.contrato,
                        valor: e.target.value,
                        codigo: user.validaciones.codigo,
                        telefono:
                          user.afiliado1.telefono || user.afiliado2.telefono,
                      })
                    }
                  />
                </div>
              </div>

              <div className="payment-action">
                <button type="submit" className="button--submit-pay">
                  Generar pago
                </button>
              </div>
            </form>
          </article>
        </section>
      ) : (
        <Load />
      )}
    </>
  );
};

export default DetailsPay;
